import React, { FC } from 'react'
import moment from 'moment'
import { DateMetricData, VerticalBorder } from './styles'

interface DateViewProps {
  hours: string;
  data: any[];
  isMobile: boolean;
}

const dateFormats: Record<string, string> = {
  '1': 'LT',
  '1h': 'LT',
  '24': 'LT',
  '24h': 'LT',
  '11111': 'MMM D',
  '168': 'll',
  '14days': 'll',
  '720': 'll',
  '30days': 'll',
  all: 'll',
}

export const selectDateTicks = (data: any[], maxTicks: number) => {
  if (data.length <= maxTicks || maxTicks < 2) {
    return data
  }

  const lastIndex = data.length - 1
  return Array.from({ length: maxTicks }, (_, index) => (
    data[Math.round((index * lastIndex) / (maxTicks - 1))]
  ))
}

export const getTickPosition = (item: any, index: number, total: number) => {
  const position = Number(item?.[0])

  if (Number.isFinite(position)) {
    return Math.min(100, Math.max(0, position))
  }

  return total > 1 ? (index * 100) / (total - 1) : 0
}

export const DateGrid: FC<{ data: any[] }> = ({ data }) => (
  <>
    {data.map((item: any, index: number) => {
      const position = getTickPosition(item, index, data.length)
      return <VerticalBorder key={`${item?.[2] ?? 'grid'}-${index}`} $position={position} />
    })}
  </>
)

const DateView: FC<DateViewProps> = ({ hours, data, isMobile }) => {
  const format = isMobile && dateFormats[hours] === 'll' ? 'MMM D' : dateFormats[hours]

  if (!format || data.length === 0) {
    return null
  }

  return (
    <>
      {data.map((item: any, index: number) => {
        const position = getTickPosition(item, index, data.length)
        return (
          <DateMetricData
            key={`${item?.[2] ?? 'date'}-${index}`}
            $position={position}
          >
            {moment(item[2]).format(format)}
          </DateMetricData>
        )
      })}
    </>
  )
}

export default DateView
